import { STATUS_COLORS } from '../../constants';

export interface IThresholdStatus {
  color: string;
  border: string;
  label: string;
}

function resolveThresholdTier(
  value: number,
  breakpoints: [number, number],
  higherIsBetter: boolean
): 'good' | 'ok' | 'poor' {
  const [lo, hi] = breakpoints;
  if (higherIsBetter) {
    if (value >= hi) return 'good';
    if (value >= lo) return 'ok';
    return 'poor';
  }
  if (value < lo) return 'good';
  if (value < hi) return 'ok';
  return 'poor';
}

export function getThresholdStatus(
  value: number,
  breakpoints: [number, number],
  labels: { low: string; mid: string; high: string },
  higherIsBetter: boolean
): IThresholdStatus {
  const tier = resolveThresholdTier(value, breakpoints, higherIsBetter);
  const labelKey =
    tier === 'ok'
      ? 'mid'
      : higherIsBetter
      ? tier === 'good'
        ? 'high'
        : 'low'
      : tier === 'good'
      ? 'low'
      : 'high';
  return {
    color: STATUS_COLORS[tier].fill,
    border: STATUS_COLORS[tier].border,
    label: labels[labelKey],
  };
}

export function getBreakpointColor(
  value: number,
  breakpoints: [number, number],
  higherIsBetter: boolean
): string {
  return STATUS_COLORS[resolveThresholdTier(value, breakpoints, higherIsBetter)]
    .fill;
}
